// extracted by mini-css-extract-plugin
var _1 = "Feedback_demo__3beb7";
var _2 = "Feedback_icon__95ed2";
var _3 = "Feedback_root__bf33e";
var _4 = "Feedback_text__6bccf";
var _5 = "Feedback_wrapper__e73ba";
export { _1 as "demo", _2 as "icon", _3 as "root", _4 as "text", _5 as "wrapper" }
